import React from 'react';
import Icon from '../assets/Icon1.png';
import Icon2 from '../assets/Icon2.png';
import Icon3 from '../assets/Icon3.png';
import {BsDot} from 'react-icons/bs';
import { HashLink as Link } from 'react-router-hash-link';


const Services = () => {
  return (
    <div className='flex flex-col  pt-24 pb-12 px-20 '>
        <div className='flex gap-8 items-center'>
            <div className='h-fit overflow-scroll flex'>
                <div className='flex gap-6'>
                    <div className='flex px-4 py-8 flex-col gap-3 bg-white shadow-lg'>
                        <span className='w-12 h-12'><img src={Icon} alt='' className='w-full h-full'></img></span>
                        <span className='uppercase font-normal opacity-80 text-lg'>Logo & brand identity</span>
                        <span className='opacity-80 font-normal  text-base w-80'>Make your business identity as unique as possible</span>
                    </div>
                    <div className='flex px-4 py-8 flex-col gap-3 bg-white shadow-lg'>
                        <span className='w-12 h-12'><img src={Icon} alt='' className='w-full h-full'></img></span>
                        <span className='uppercase font-normal opacity-80 text-lg'>Campaign Management</span>
                        <span className='opacity-80 font-normal  text-base w-80'>Make your business identity as unique as possible</span>
                    </div>
                    <div className='flex px-4 py-8 flex-col gap-3 bg-white shadow-lg'>
                        <span className='w-12 h-12'><img src={Icon} alt='' className='w-full h-full'></img></span>
                        <span className='uppercase font-normal opacity-80 text-lg'>Traditional media + advertising</span>
                        <span className='opacity-80 font-normal  text-base w-80'>Make your business identity as unique as possible</span>
                    </div>
                </div>
            </div>
            <div className='flex flex-col gap-5'>
                <span><hr className='h-2 w-28 bg-[#273773]'/></span>
                <span className='flex flex-col text-5xl tracking-wider font-medium gap-1'>
                    <span className=''>Choose The Services </span>
                    <span className=''>Your Business Needs</span>
                </span>
                <span className='text-lg font-light tracking-wider opacity-80 w-[32rem]'>Vyda Agency isn't just a marketing agency; it's a powerhouse of creativity, PR mastery, and strategic brilliance. </span>
                <span className='text-base underline text-[#273773]'> choose services</span>
            </div>
        </div>
        
    </div>
  )
}

export default Services;